module.exports = __webpack_public_path__ + "img/jwoshou.403a1c55.gif";